import { render } from "./templates-table.vue?vue&type=template&id=2db1e9f4"
import script from "./templates-table.vue?vue&type=script&lang=js"
export * from "./templates-table.vue?vue&type=script&lang=js"

import "./templates-table.vue?vue&type=style&index=0&id=2db1e9f4&lang=scss"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__